import { Col, Row,  } from "antd";
import ListItems from "./Components/ListItems";
import { useGetNotifications } from "./ServerSideStates";
import ReadAllNotifications from "./Components/ReadAllNotification";
import PageTitle from "apps/Common/PageTitle";
import { Helmet } from "react-helmet-async";




const NotificationIndex = () => {
 
  const notifications= useGetNotifications();
  console.log("notifications",notifications)
  return (
    <>
      <Col xs={24}
      className="!p-0"
      >
        <Helmet>
                      <title className="capitalize">{"Bildirim Listesi"}</title>
                    </Helmet>
        <Row 
        
        gutter={[
          { xs: 10, md:10 , xl:10 }, 
          { xs:10 , md: 15, xl:20}   
        ]}
        className="">
          
          <Col span={24} className="!flex justify-center">
          <PageTitle
          title="Bildirim Listesi"
          count={notifications?.data?.data?.length}
          />
            
          </Col>
          {
            (()=>{
              let allData = notifications?.data?.data||[]
              let unReadNotifications = allData.find((item:any)=>!item.isRead)
              if(unReadNotifications)
              {
                return(
                  <Col xs={24}  className="!flex justify-end" >
                  <ReadAllNotifications/>
                  </Col>
                )
              }
              return <></>
            })()
          }

         

          <Col xs={24} className="">
           <ListItems/>
          </Col>
        </Row>
      </Col>
      <></>
    </>
  );
};

export default NotificationIndex;
